import React from 'react'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

import '../../../stylesheets/components/dtcs/index.scss'

import DefPlugin from '../../../components/vehicle/plugin/def'
import PluginStore from '../../../components/vehicle/plugin/def/context/context'
import SalesCodeComplexity from '../../../components/vehicle/plugin/sales_code_complexity'
import SalesCodeComplexityStore from '../../../components/vehicle/plugin/sales_code_complexity/context/context'
import { useLocation } from 'react-router-dom'

const TabIndexes = {
  '#sales_code_complexity': 1,
  '#def_plugin': 0,
}

const Plugin = ({}) => {
  const location = useLocation()

  return (
    <Tabs
      variant="fullWidth"
      style={{ width: '100%' }}
      defaultIndex={TabIndexes[location.hash]}
    >
      <TabList>
        <Tab>DEF Plugin</Tab>
        <Tab>Sales Code Complexity</Tab>
      </TabList>

      <TabPanel>
        <PluginStore>
          <DefPlugin />
        </PluginStore>
      </TabPanel>
      <TabPanel>
        <SalesCodeComplexityStore>
          <SalesCodeComplexity />
        </SalesCodeComplexityStore>
      </TabPanel>
    </Tabs>
  )
}

Plugin.propTypes = {}

export default Plugin
